<div class="container" [class.fail]="isFailed">
  <div class="content" *ngIf="!isFailed">
    {{ text }}
  </div>
  <div
    class="analyze-svg"
    inlineSVG="/assets/icons/loader3-small.svg"
    *ngIf="!isFailed"
  ></div>
  <div
    class="fail"
    *ngIf="isFailed"
    inlineSVG="/assets/icons/fail-icon-thum.svg"
  ></div>
  <icn-close-btn *ngIf="canRemove" (remove)="onRemove()"></icn-close-btn>
</div>
